import { render, staticRenderFns } from "./AddNewPavementModal.vue?vue&type=template&id=678edbcc"
import script from "./AddNewPavementModal.vue?vue&type=script&lang=js"
export * from "./AddNewPavementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports